<div class="modal__sac" *ngIf="exibir">
  <div class="animated fadeIn">
    <span class="fa fa-times-circle fa-2x modal__sac__close" (click)="fecharPopup()"></span>
    <p class="sac__p">Estamos sempre à disposição através da nossa central de relacionamento com o cliente:</p>
    <p class="sac__p">Capitais e região metropolitana ligue:</p>
    <p class="sac__p"> <b>4004-2987</b>.</p>
    <p class="sac__p">demais localidades <b>0800 11 9263</b> de segunda a sexta das 08:00 às 17:00.</p>
    <p class="sac__p">
      Ou nos envie um e-mail para: <b>sac@cacaushow.com.br</b>
    </p>
  </div>
</div>
